import React, { createContext, useContext, useState, useEffect } from "react";
import { gql, useQuery } from "@apollo/client";

const RecipeValidationContext = createContext();

export const VALIDATE_RECIPE_ID_QUERY = gql`
  query ValidateRecipeId($id: ID!) {
    validateRecipeId(id: $id)
  }
`;

export const RecipeValidationProvider = ({ children, recipe_id }) => {
  const [isValid, setIsValid] = useState(null);

  const { data, loading, error } = useQuery(VALIDATE_RECIPE_ID_QUERY, {
    variables: { id: parseInt(recipe_id) },
    skip: !recipe_id, // Skip the query if recipe_id is not available
  });

  useEffect(() => {
    if (!loading && data) {
      const parsedData =
        typeof data?.validateRecipeId === "string"
          ? JSON.parse(data?.validateRecipeId)
          : data?.validateRecipeId;
    //   console.log(parsedData);
      const { isExist, isAuthor } = parsedData;
      setIsValid({ isExist, isAuthor });
    }

    if (error) {
      console.error("Error validating recipe ID:", error);
      setIsValid({ isExist: false, isAuthor: false, error });
    }
  }, [loading, data, error]);

  return (
    <RecipeValidationContext.Provider value={isValid}>
      {children}
    </RecipeValidationContext.Provider>
  );
};

export const useRecipeValidation = () => {
  return useContext(RecipeValidationContext);
};
